import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const tenantsSlice = createSlice({
    name: "tenants",
    initialState,
    reducers: {
        setAllTenants: (state, action) => {
            state = action.payload
        },
    }
});

export const SelectTenants = (state) => state.tenants;

export const { setAllTenants } = tenantsSlice.actions;

export default tenantsSlice.reducer;